module.exports = __webpack_public_path__ + "static/media/avatarDefault.c133bcb3.svg";